<template>
  <div class="result-item" :class="{'is-current': isCurrent}" :style="styles">
    <div class="headding">
      <span class="years-num">{{resultData.name1}}</span>
      <span class="years-title">{{resultData.name2}}</span>
    </div>
    <div class="summery-area">
      <p class="summery" v-html="resultData.summary"></p>
    </div>
    <transition name="result">
      <div class="result-area" v-if="isOpen">
        <p class="main-result" v-html="resultData.text1"></p>
        <p class="additional-result" v-if="isCurrent">
          <span class="title">この時期悩んでいるなら</span>
          <span class="result-body" v-html="resultData.text2"></span>
        </p>
      </div>
    </transition>
    <accordion-btn :is-open="isOpen" @accbtn-click="onAccBtnClick"/>
  </div>
</template>

<script>
import AccordionBtn from '@/utvStore/components/partials/AccordionBtn'

export default {
  name: 'ResultItem',
  components: {
    AccordionBtn,
  },
  props: {
    resultData: {
      type: Object,
      default(){
        return {}
      },
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      },
    }
  },
  data(){
    return {
      isOpen: false,
    }
  },
  computed: {
    isCurrent(){
      return this.resultData.text2.length > 0
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--profile-key-color': this.colorScheme.profileKeyColor,
      }
    }
  },
  created() {
    this.isOpen = this.isCurrent
  },
  methods: {
    onAccBtnClick(){
      this.isOpen = !this.isOpen
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
$line_gradient: linear-gradient(270deg, #ffc0bd 0%, #c39fe0 100%);
p {
  margin: 0 0 8px;
}
.headding {
  display: block;
  width: 100%;
  position: relative;
  padding: 0 0 8px;
  margin-bottom: 16px;
  color: var(--key-color);
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  @include mq('w580'){
    font-size: 18px;
    padding: 0 0 18px;
    margin-bottom: 18px;
  }
  &::after {
    content: "";
    width: 100%;
    height: 2px;
    background: $line_gradient;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.result-item {
  color: #32373f;
  background: white;
  margin-bottom: 16px;
  padding: 24px 20px 12px;
  font-size: 14px;
  line-height: 24px;
  position: relative;
  @include mq('w580'){
    padding: 24px 40px 12px;
    font-size: 15px;
  }
  &.is-current {
    padding: 30px 20px 12px;
    background: #fffdf2;
    &::before {
      content: "現在";
      width: 72px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      line-height: 1;
      color: white;
      background: var(--profile-key-color);
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.main-result {
  padding-top: 12px;
}

.additional-result {
  //background: #fbf8f1;
  background: white;
  padding: 12px 16px 24px;
  @include mq('w580') {
    margin: 24px 0 24px;
  }
  .title {
    display: block;
    width: 100%;
    position: relative;
    padding: 0 0 8px;
    margin-bottom: 12px;
    &::after {
      content: "";
      width: 100%;
      height: 1px;
      background: $line_gradient;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}

.result {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    opacity: 0;
    transform: translate(0, -30px);
  }
  &-enter-to, &-leave {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/partials/ResultItem.vue